import React, { useEffect, useState } from "react";

import {  useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getPermission } from "../../utils/helper";
import NotExist from "../About/NotExist";
import Loader from "../../layout/Loader";
import DynamicPricing from "./DynamicPricing";
import OccupancyPrediction from "./OccupancyPrediction";
import MarketAnalysis from "./MarketAnalysis";
import BookingPattern from "./BookingPattern";
import AddMarketHotelDialog from "./MarketAnalysisComponent/AddMarketHotelDialog";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";


const RevenueGeneration = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [viewPermission, setViewPermission] = useState(null);
  const auth = useSelector((state) => state.auth);

  const getPermissions = async () => {
    const ViewPermission = await getPermission("Revenue Generation", 2);
    setViewPermission(ViewPermission);
    setInitLoading(false);
  };
  useEffect(() => {
    if (Object.keys(auth?.permission)?.length > 0) {
      getPermissions();
    }
  }, [auth]);

  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    if (!initLoading && viewPermission?.hasPermission !== null) {
      if (searchParams.get("tab")) {
        handletabs(searchParams.get("tab"));
      } else {
        handletabs("occupancy-prediction");
      }
    }
  }, [searchParams, initLoading]);
  const { t } = useTranslation();
  const [tabName, setTabName] = useState("Occupancy Prediction");
  const [openAddHotelDialog, setOpenAddHotelDialog] = useState(false);



  const handletabs = (e) => {
    document.getElementById("occupancy-prediction").classList.remove("active-tab");
    document.getElementById("market-analysis").classList.remove("active-tab");
    document.getElementById("booking-pattern").classList.remove("active-tab");
    // document.getElementById("dynamic-pricing").classList.remove("active-tab");
    document.getElementById(e).classList.add("active-tab");
    // console.log('ee',e)
    setTabName(e);
    setSearchParams({ tab: e });
  };

  return (
    <>
      {viewPermission?.hasPermission !== null && !initLoading ? (
        <div className="main-layout-background h-auto">
          <div className="d-flex mt-2rem justify-content-between flex-wrap gap-2">
            <div className="d-flex align-items-center">
              <h1 className="pagename-heading">{t("Revenue Generation")}</h1>
              <p className="">
                {" "}
                {t("Home")} / {t(tabName)}
              </p>
            </div>
            <div className="pr-2">
              {/* {tabName == "dynamic-pricing" && (
                <Button
                  size="large"
                  variant="contained"
                  disableElevation
                  className="comman-button"
                  color="primary"
                  onClick={() => setOpenAddHotelDialog(true)}
                >
                  {t("Add Dynamic Price")}
                </Button>
              )} */}
              {tabName == "market-analysis" && (
                <Button
                  size="large"
                  variant="contained"
                  disableElevation
                  className="comman-button"
                  color="primary"
                  onClick={() => setOpenAddHotelDialog(true)}
                >
                  {t("Add Market's Hotel")}
                </Button>
              )}

            </div>
          </div>
          <div className="nav-header  justify-content-start">
            <div
              id="occupancy-prediction"
              onClick={() => handletabs("occupancy-prediction")}
              className={`nav-tab h-25p text-16 active-tab`}
            >
              {t("Occupancy Prediction")}
            </div>
            <div
              id="market-analysis"
              onClick={() => handletabs("market-analysis")}
              className={`nav-tab h-25p text-16 active-tab`}
            >
              {t("Market Analysis")}
            </div>
            <div
              id="booking-pattern"
              onClick={() => handletabs("booking-pattern")}
              className={`nav-tab h-25p text-16 active-tab`}
            >
              {t("Booking Pattern")}
            </div>

            {/* <div
              id="dynamic-pricing"
              onClick={() => handletabs("dynamic-pricing")}
              className={`nav-tab h-25p text-16 active-tab`}
            >
              {t("Dynamic Pricing")}
            </div> */}
          </div>
          {/* <div className="nav-header h-61p mt-1 border-bottom-0"></div> */}

          <div className="mt-3 pl-md-2 pr-md-2">
            {tabName === "occupancy-prediction" && <OccupancyPrediction/>}
            {tabName === "dynamic-pricing" && <DynamicPricing/>}
            {tabName === "market-analysis" && <MarketAnalysis/>}
            {tabName === "booking-pattern" && <BookingPattern/>}
          </div>
           <AddMarketHotelDialog
                      openAddHotelDialog={openAddHotelDialog}
                      setOpenAddHotelDialog={setOpenAddHotelDialog}
                    />
        </div>
       ) : initLoading ? (
        <Loader />
      ) : (
        <div className="mt-5">
          <NotExist />
        </div>
      )} 
    </>
  );
};


export default RevenueGeneration;
